var _ = {};
_.every = require('lodash.every');

module.exports = function (ko) {
    ko.validation.rules.phone_number = {
        validator: function (val, validate) {
            return validate ? String(val).replace(/\D/g, '').length > 7 : true;
        },
        message: 'Phone numbers have got to have numbers in them.'
    };
    ko.validation.rules.array_members_valid = {
        validator: function (array, validate) {
            return validate ? _.every(array, function (val) {
                return val.isValid();
            }) : true;
        },
        message: 'Please fill out every field'
    };
// https://github.com/Knockout-Contrib/Knockout-Validation/wiki/User-Contributed-Rules
    ko.validation.rules.same_as = {
        validator: function (val, other_value) {
            return val === ko.unwrap(other_value);
        },
        message: 'The fields must have the same value'
    };
    ko.validation.registerExtenders();
};